import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Box, Grid, Button, Tooltip, TextField, Chip } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { SmsTemplateQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import { SCUISmsTemplateDrawerContent } from './components/SCUISmsTemplateDrawerContent';
import { SCUIButton } from '../../atomic/atoms';
import { Edit } from '@mui/icons-material';
import { SMS } from './smsTemplate.classes';

export const SmsTemplate: FC = () => {
    const { t } = useTranslation();
    const [state, setState] = useState({
        right: false,
    });
    const [storelist, setStoreList] = useState([]);
    const [store, setStore] = useState<any>();
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [refresh, setRefresh] = useState(false);
    const [searchedKeyword, setSearchedKeyword] = useState('');
    const [searchedList, setSearchedList] = useState<any>([]);

    const refreshSmsTemplate = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        getSms();
    }, [refresh]);
    const requestSearchKeyword = (searchedVal: any) => {
        setSearchedKeyword(searchedVal.target.value);
        let filteredRoles = storelist.filter(
            (o: any) => o.smsTemplateKeyword.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setSearchedList(filteredRoles);
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'smsTemplateKeyword',
            headerName: t('smsTemplate.keyword'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div className={SMS.cellKeyword} data-keyword={params.row.smsTemplateKeyword}>
                        <Tooltip title={<h2>{params.row.smsTemplateKeyword}</h2>}>
                            <p className={SMS.cellKeywordText}>{params.row.smsTemplateKeyword}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'cultureCode',
            headerName: t('smsTemplate.cultureCode'),
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SMS.cellCultureCode} data-culture-code={params.row.cultureCode}>
                    {params.row.cultureCode}
                </span>
            ),
        },
        {
            field: 'subject',
            headerName: t('smsTemplate.subject'),
            flex: 1,
            hide: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <span className={SMS.cellSubject} data-subject={params.row.subject}>
                    {params.row.subject}
                </span>
            ),
        },
        {
            field: 'body',
            headerName: t('smsTemplate.body'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div
                        className={SMS.cellBody}
                        data-keyword={params.row.smsTemplateKeyword}
                        data-body={params.row.body}
                    >
                        <Tooltip title={<h2>{params.row.body}</h2>}>
                            <p className={SMS.cellBodyText}>{params.row.body}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'isActive',
            headerName: t('smsTemplate.isActive'),
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const active = params.row.isActive && params.row.isActive === true;
                return (
                    <div className={SMS.cellIsActive}>
                        <Chip
                            className={`${SMS.statusChip} ${active ? SMS.statusChipActive : SMS.statusChipPassive}`}
                            data-is-active={String(active)}
                            data-keyword={params.row.smsTemplateKeyword}
                            color={active ? 'success' : 'error'}
                            label={active ? t('general.active') : t('general.passive')}
                        />
                    </div>
                );
            },
        },
        {
            field: 'düzenle',
            headerName: t('general.edit'),
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setStore(params.row);
                    onDrawerOpen();
                };
                return (
                    <div className={SMS.cellEdit}>
                        <Button
                            onClick={onclick}
                            className={SMS.btnEdit}
                            data-keyword={params.row.smsTemplateKeyword}
                        >
                            <Edit />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const getSms = () => {
        SmsTemplateQuery.GetSmsTemplate()
            .then((res: any) => {
                if (res) {
                    let parseData = res.map((item: any) => {
                        return {
                            smsTemplateKeyword: item.smsTemplateKeyword || '',
                            cultureCode: item.cultureCode || '-',
                            subject: item.subject || '-',
                            body: item.body || '-',
                            isActive: item.isActive || 'false',
                            arrayKeyword: item.templateKeyArr,
                        };
                    });
                    setStoreList(parseData);
                    setSearchedList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    return (
        <SCUIContent className={SMS.page}>
            <Box className={SMS.root}>
                <Grid
                    className={SMS.header}
                    size={{
                        lg: 10,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h1 className={`headtxt ${SMS.title}`}>{t('smsTemplate.title')}</h1>
                </Grid>
                <Grid
                    container
                    justifyContent="flex-end"
                    className={SMS.headerActions}
                    size={{
                        xs: 12,
                        sm: 12,
                    }}
                >
                    <SCUIButton
                        className={SMS.btnAdd}
                        text={t('smsTemplate.add')}
                        sizeType="fixed"
                        style={{ margin: '16px 0' }}
                        type="primary"
                        size={'l'}
                        onClick={() => {
                            setStore([]);
                            onDrawerOpen();
                        }}
                    ></SCUIButton>
                </Grid>
                <Grid
                    className={SMS.searchBox}
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={SMS.inputSearch}
                        placeholder={t('smsTemplate.search')}
                        value={searchedKeyword}
                        onChange={(searchVal) => requestSearchKeyword(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Box className={SMS.drawer}>
                    <SCUIGeneralDrawer
                        open={state['right']}
                        anchor="right"
                        width={'500px'}
                        onClose={(event: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setState({ ...state, right: false });
                            }
                        }}
                    >
                        <SCUISmsTemplateDrawerContent
                            selectedRow={store}
                            onCloseMenu={onDrawerClose}
                            onUpdate={refreshSmsTemplate}
                        />
                    </SCUIGeneralDrawer>
                </Box>
                <Box className={SMS.grid}>
                    <SCUICustomDataGrid randomId rows={searchedList} columns={columns} />
                </Box>
            </Box>
        </SCUIContent>
    );
};
